import BN from 'bn.js';

const useNormalizeType = (item) => {
  const { type, activity_data } = item;
  const { amount, amounts, staked_amount } = activity_data;
  let title: string;
  let label: string;
  let value: string;

  const sumAmounts = (amountsArr: string[]): string => {
    if (!amountsArr?.length) return '0';

    return amountsArr
      .reduce((sum, value) => sum.add(new BN(value)), new BN(0))
      .toString();
  };

  switch (type) {
    case 'opn_send':
      title = 'Sent OPN';
      label = 'OPN';
      value = amount;
      break;
    case 'occ_send':
      title = 'Sent OCC';
      label = 'OCC';
      value = amount || sumAmounts(amounts)
      break;
    case 'opn_received':
      title = 'Received OPN';
      label = 'OPN';
      value = amount || staked_amount;
      break;
    case 'occ_received':
      title = 'Received OCC';
      label = 'OCC';
      value = amount || sumAmounts(amounts)
      break;
    case 'plant':
      title = 'Plant OPN';
      label = 'OPN';
      value = amount;
      break;
    case 'opn_withdraw':
      title = 'Withdrawn OPN';
      label = 'OPN';
      value = amount;
      break;
    case 'occ_withdraw':
      title = 'Withdrawn OCC';
      label = 'OCC';
      value = sumAmounts(amounts);
      break;
    case 'offset':
      title = 'Retired OCC';
      label = 'OCC';
      value = sumAmounts(amounts)
      break;
  }
  return { amount: value, label, title };
};

export default useNormalizeType;
